import { Component, input, output, signal, computed, effect } from '@angular/core';
import { CardComponent } from '@lp-ui-lib';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { AssetNavButtonComponent } from '@lp-ui-lib';
import { NameSlicePipe } from '@lp-ui-lib';

@Component({
  selector: 'app-map-overlay',
  imports: [CardComponent, NzModalModule, AssetNavButtonComponent, NameSlicePipe],
  templateUrl: './map-overlay.component.html',
  styleUrls: ['./map-overlay.component.scss'],
})
export class MapOverlayComponent {
  // Signals
  overlayPlant = signal<any | null>(null);
  critical = signal<number>(0);
  buildings = signal<any[]>([]);

  // Input using Angular 20 `input()` API
  OverlayPlant = input<any>({
    set: (plant: any) => {
      this.overlayPlant.set(plant);
    },
  });

  // Output using Angular 20 `output()` API
  closed = output<void>();

  // Computed signals
  computedCritical = computed(() => this.overlayPlant()?.Critical.length ?? 0);

  computedBuildings = computed(() => {
    const plant = this.overlayPlant();
    if (!plant) return [];
    return plant.children.map((building: any) => {
      return {
        ...building,
        critical_length: building.Critical.length,
        children: building.children.map((equipment: any) => ({
          ...equipment,
          critical_length: equipment.Critical.length,
          critical_children: equipment.Critical,
        })),
      };
    });
  });

  // Effects to update signals when overlayPlant changes
  overlayEffect = effect(() => {
    const plant = this.overlayPlant();
    if (!plant) return;
    this.critical.set(this.computedCritical());
    this.buildings.set(this.computedBuildings());
  });
}
